import { SecondaryButton } from "@/components/buttons/SecondaryButton";
import { Button, Modal, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useDownloadCommissionsBatchInactiveAgentsExport } from "../../../../../common/api/queries";
import { ExportFileType } from "../../../../../common/enums";
import { UUID } from "../../../../../typings/global";

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
  batchId: UUID;
};

export const ExportInactiveAgentsFileTypeQuestionModal = ({ isOpen, onClose, batchId }: Props) => {
  const { t } = useTranslation();

  const downloadCommissionsBatchInactiveAgentsExport = useDownloadCommissionsBatchInactiveAgentsExport();

  return (
    <Modal
      open={isOpen}
      title={t("commissions.batch.helpers.exportInactiveAgentsFileTypeQuestion")}
      onCancel={onClose}
      footer={
        <Space>
          <Button
            type="primary"
            onClick={() => {
              downloadCommissionsBatchInactiveAgentsExport.mutate({
                id: batchId,
                object: { exportFileType: ExportFileType.XLSX },
              });

              onClose();
            }}
          >
            {t("common.exportXlsx")}
          </Button>

          <SecondaryButton
            onClick={() => {
              downloadCommissionsBatchInactiveAgentsExport.mutate({
                id: batchId,
                object: { exportFileType: ExportFileType.CSV },
              });

              onClose();
            }}
          >
            {t("common.exportCsv")}
          </SecondaryButton>
        </Space>
      }
    />
  );
};
